// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "li[data-v-189d4bd7]{margin:0 0 1em;padding:0 0 0 1.6em;position:relative}li img[data-v-189d4bd7]{display:inline-block;height:1.2em;left:0;position:absolute;width:1.2em}.warning[data-v-189d4bd7]{font-weight:700}.campsite-notices[data-v-189d4bd7] .google-translate{margin-left:1.6em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
